module.exports = __webpack_public_path__ + "img/faceId.eb1f9e62.png";